<script>
  import { Button } from "@tastyworks/ui-library"
  import { _ } from "svelte-i18n"
  import InformationalDialog from "./InformationalDialog.svelte"

  const prefix = "personalInfo.citizenshipStatus.acceptableVisaTypes"

  let { open = $bindable(false), onClose } = $props()
</script>

<InformationalDialog title={$_(`${prefix}.title`)} bind:open {onClose}>
  {#snippet descriptionSnippet()}
    <div class="font-small-400">
      <p>
        {$_(`${prefix}.description`)}
      </p>
      <ul class="list-disc pb-4 pl-4 pt-4">
        {#each $_(`${prefix}.list`) as item}
          <li>
            {item}
          </li>
        {/each}
      </ul>
      <Button
        variant="link"
        class="p-0 font-small-400"
        target="_blank"
        href="https://support.tastytrade.com/s/solutions/articles/43000522511"
      >
        {$_(`${prefix}.link`)}
      </Button>
    </div>
  {/snippet}
</InformationalDialog>
